module.exports = __webpack_public_path__ + "img/teacher.dc4315d9.png";